// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-table-column-image{width:100%}.lc-am-table-column-link:hover{text-decoration:underline;text-underline-offset:3px}.lc-am-table-column-group-label{width:100%!important}", ""]);
// Exports
module.exports = exports;
